export const TRANSACTION_REQUEST_STATE_ENUM = {
    INIT: 'init',
    PENDING: 'pending',
    READY: 'ready',
    PROCESSED: 'processed',
    REJECTED: 'rejected',
};
